import { type IIconsProps } from 'ui/src/components/Icon';

/**
 * MobileHeader Site Theme Classes
 */

const mobileHeaderIconToggleClasses = 'block mdL:hidden';

const mobileMenuThemeClasses =
  'block fixed top-20 left-0 h-fit w-full bg-site-neutrals-0 text-site-neutrals-900 z-50 max-h-screen';

const mobileMenuNavClasses = 'flex flex-col items-start justify-center [&>ul]:w-full gap-6 pb-24 [&>button]:ml-8';

const mobileMenuNavListItemClasses = 'flex flex-col items-start justify-center px-8 py-4 gap-6';
const mobileMenuNavListItemActiveClasses = 'bg-site-neutrals-25';

const mobileMenuNavListItemNameClasses = 'site-paragraph-m font-bold w-full flex items-center gap-1';

const mobileMenuSectionTitleClasses = 'site-overline-s text-site-neutrals-400 font-bold uppercase px-8 mt-8 -mb-1';

const mobileMenuSectionDividerClasses = 'border-site-neutrals-100 mt-6 mb-8 border';
/**
 * MobileHeader Site Theme Icon Props
 */

const mobileMenuDropdownIconProps: IIconsProps = {
  bg: false,
  size: 'IconS',
  className: 'bg-site-neutrals-800',
};

/**
 * MobileHeader Site Theme
 */

const mobileHeaderSiteTheme = {
  mobileHeaderIconToggleClasses,
  mobileMenuThemeClasses,
  mobileMenuNavClasses,
  mobileMenuNavListItemClasses,
  mobileMenuNavListItemActiveClasses,
  mobileMenuNavListItemNameClasses,
  mobileMenuDropdownIconProps,
  mobileMenuSectionTitleClasses,
  mobileMenuSectionDividerClasses,
};

export default mobileHeaderSiteTheme;
